export default "__VITE_ASSET__CfWx$t_E__"